import { type Event } from '@patsnap/tahiti-core/common/event';
import type { SSEResponse } from '@patsnap-utils/sse';
import { StreamStatus } from '@/services/ai-translation/type/ai-translation.enum';

export const StreamService = Symbol('StreamService');

export interface StreamEvents<Response> {
    onOpen?: (response: Response) => void;
    onMessage?: (data: SSEResponse<Response>) => void;
    onError?: (err: any) => void;
    onClose?: () => void;
}

export interface StreamService<Content> {
    readonly onStatusChange: Event<string>;
    readonly onContentChange: Event<Content>;
    abort: () => void;
    execute: (input: { [key: string]: any }) => void;
    stopLoading: () => void;
    status: StreamStatus;
}
